import { makeEnum, makeOptions,
  setupClass, lookupData, 
} from '../Base.js'
import { generateItemName, sortItemsByName, } from '../SharedUtils.js'

export { Units } from '../Common/Units.js'

import {
  FieldType,
  Field,
} from '../Common/Field.js'

import { gApp, DebugOn } from '../Globals.js'


export class ExteriorShadingType {
  init(name, makeId) {
    this.id = makeId ? gApp.proj().makeId('ExteriorShadingType') : 0;
    this.name = Field.makeName('Name', name)

    this.horizontalFinDepth = new Field({
      name: 'Depth',
      type: FieldType.Length,
      min: 0,
      allowMin: true,
      note: 'How far the horizontal fin (overhang) projects out from the wall. Set to 0 if there is no overhang.',
    })
    this.horizontalFinDist = new Field({
      name: 'Distance from parallel edge',
      type: FieldType.Length,
      min: 0,
      allowMin: true,
      note: 'Distance from the top edge of the window to the underside of the horizontal fin.',
    })
    this.horizontalFinFields = [
      'horizontalFinDepth',
      'horizontalFinDist',
    ]

    this.leftFinDepth = new Field({
      name: 'Depth',
      type: FieldType.Length,
      min: 0,
      allowMin: true,
      note: 'How far the left vertical fin projects out from the wall. Set to 0 if there is no left fin.',
    })
    this.leftFinDist = new Field({
      name: 'Distance from parallel edge',
      type: FieldType.Length,
      min: 0,
      allowMin: true,
      note: 'Distance from the left edge of the window to the left fin.',
    })
    this.leftFinFields = [
      'leftFinDepth',
      'leftFinDist',
    ]

    this.rightFinDepth = new Field({
      name: 'Depth',
      type: FieldType.Length,
      min: 0,
      allowMin: true,
      note: 'How far the right vertical fin projects out from the wall. Set to 0 if there is no right fin.',
    })
    this.rightFinDist = new Field({
      name: 'Distance from parallel edge',
      type: FieldType.Length,
      min: 0,
      allowMin: true,
      note: 'Distance from the right edge of the window to the right fin.',
    })
    this.rightFinFields = [
      'rightFinDepth',
      'rightFinDist',
    ]

    this.serFields = [
      'id',
      'name',
      'horizontalFinDepth',
      'horizontalFinDist',
      'leftFinDepth',
      'leftFinDist',
      'rightFinDepth',
      'rightFinDist',
    ]
    this.childObjs = '$auto'
    this.objInfo = {
      _name: 'Exterior Shading',
      uniquePath: true,
      path: () => {
        return `externalshadings/${this.id}`
      }
    }
  }

  static getTypeMetadata() {
    return {
      name: 'Exterior Shading',
      createType: ExteriorShadingType.createType,
      openEditor: ExteriorShadingType.openEditor,
      customEditor: true,
    }
  }

  static createType() {
    let type = ExteriorShadingType.create(generateItemName('Exterior Shading', gApp.proj().exteriorShadingTypes), true)
    gApp.proj().exteriorShadingTypes.push(type);
    sortItemsByName(gApp.proj().exteriorShadingTypes);
    return type
  }

  static openEditor(type) {
    let pathName = gApp.proj().isCommercial() ? 'building-externalshadings' : 'externalshadings';
    gApp.proj().editorState.selectedExteriorShading = type;
    gApp.router.push({name: pathName});
  }

  static getTableInfo() {
    return {
      typeName: 'Exterior Shading',
      pagePath: 'externalshadings',
      newItemName: 'ExShading-$CTR',
      allowDuplicate: true,
      columns: {
        'name': {
          label: 'Name',
        },
        'horizontalDepth': {
          label: 'Horizontal Depth',
        },
        'leftFinDepth': {
          label: 'Left Fin Depth',
        },
        'rightFinDepth': {
          label: 'Right Fin Depth',
        },
      }
    }
  }

  getTableData() {
    return {
      name: this.name.value,
      horizontalDepth: this.horizontalFinDepth.getDisplayValueStr(),
      leftFinDepth: this.leftFinDepth.getDisplayValueStr(),
      rightFinDepth: this.rightFinDepth.getDisplayValueStr(),
    }
  }

  getInputPage() {
    return {
      label: `${this.name.value}`,
      // TODO
      path: `externalshadings/${this.id}`,
      typeName: 'Exterior Shading',
      typeObject: this,
    };
  }

  setTopFinValues(depth, dist) {
    this.horizontalFinDepth.setValue(depth)
    this.horizontalFinDist.setValue(dist)
  }

  hasTopFin() {
    return this.horizontalFinDepth.stdValue > 0
  }

  setLeftFinValues(depth, dist) {
    this.leftFinDepth.setValue(depth)
    this.leftFinDist.setValue(dist)
  }

  hasLeftFin() {
    return this.leftFinDepth.stdValue > 0
  }

  setRightFinValues(depth, dist) {
    this.rightFinDepth.setValue(depth)
    this.rightFinDist.setValue(dist)
  }

  hasRightFin() {
    return this.rightFinDepth.stdValue > 0
  }
};
setupClass(ExteriorShadingType)
